import { render, staticRenderFns } from "./ScoreDisplay.vue?vue&type=template&id=0ef557f2&scoped=true&"
import script from "./ScoreDisplay.vue?vue&type=script&lang=js&"
export * from "./ScoreDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ScoreDisplay.vue?vue&type=style&index=0&id=0ef557f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef557f2",
  null
  
)

export default component.exports